module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      William Shakespeare\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("William Shakespeare was an English poet, playwright, and actor. He is widely regarded as the greatest dramatist in the English language. Shakespeare is often called England’s national poet and the “Bard of Avon.”"), _c('BR'), _vm._v("  ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jIZoFc/tc-custom/9781504062985.jpg?1700680416981",
      "alt": "This image is the cover for the book Richard III"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Richard III\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("The story of the rise and fall of a murderous ruler, filled with courtly intrigue, dark humor, and psychological insight.")])]), _c('p', [_vm._v("The hunchbacked king Richard III has risen to power through deception and murder, and will stop at nothing to maintain his rule. But when all is said and done, he will pay a price for his machinations, in this historical play set in the era of the Wars of the Roses.")]), _vm._v(" A dark tale with a touch of comedy amid much tragedy, "), _c('i', [_vm._v("Richard III")]), _vm._v(", like so much of the great playwright’s work, continues to resonate with twenty-first-century culture.\n    "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0